import { render } from "./ProjectRow.vue?vue&type=template&id=83288b4a&scoped=true"
import script from "./ProjectRow.vue?vue&type=script&lang=js"
export * from "./ProjectRow.vue?vue&type=script&lang=js"

import "./ProjectRow.vue?vue&type=style&index=0&id=83288b4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83288b4a"]])

export default __exports__